import {KeywordSet} from "../KeywordSet.ts";

export const HearthstoneSet: KeywordSet = {
	id: "hearthstone",
	name: "Hearthstone keywords",
	description: "",
	time: 300,
	keywords: [
		"adapt",
		"battlecry",
		"charge",
		"colossal",
		"combo",
		"corpse",
		"corrupt",
		"counter",
		"dark gift",
		"deathrattle",
		"discover",
		"divine shield",
		"dredge",
		"echo",
		"elusive",
		"excavate",
		"finale",
		"forge",
		"freeze",
		"frenzy",
		"honorable kill",
		"imbue",
		"immune",
		"infuse",
		"inspire",
		"invoke",
		"lackey",
		"lifesteal",
		"magnetic",
		"manathirst",
		"mega-windfury",
		"mini",
		"miniaturize",
		"nature spell damage",
		"outcast",
		"overheal",
		"overload",
		"poisonous",
		"quest",
		"questline",
		"quickdraw",
		"reborn",
		"recruit",
		"rush",
		"secret",
		"sidequest",
		"silence",
		"spare parts",
		"spell damage",
		"spellburst",
		"starship",
		"start of game",
		"stealth",
		"taunt",
		"temporary",
		"titan",
		"tradeable",
		"twinspell",
		"windfury"
	]
};
